import { useState } from 'react';
import { isoToday, longDateLabel, type Page } from '@agrogruda/shared';
import { MenuIcon } from '@/components/icons/NavIcons';
import { PAGE_META, sq } from '@/i18n/sq';

export interface TopbarProps {
  page: Page;
  sidebarOpen: boolean;
  onToggleSidebar: () => void;
}

/** Prototype <header class="topbar"> (lines 945-951): mobile toggle, page title/subtitle, today label. */
export function Topbar({ page, sidebarOpen, onToggleSidebar }: TopbarProps) {
  // Computed once at load, exactly like the prototype's bootstrap IIFE (line 3135).
  const [today] = useState(() => longDateLabel(isoToday()));
  const meta = PAGE_META[page];
  return (
    <header className="topbar">
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <button
          type="button"
          className="btn icon-only mobile-toggle"
          aria-label={sq.nav.menu}
          aria-controls="sidebar"
          aria-expanded={sidebarOpen}
          onClick={onToggleSidebar}
        >
          <MenuIcon />
        </button>
        <div className="page-name">
          <h1 id="pageTitle">{meta.title}</h1>
          <p id="pageSub">{meta.subtitle}</p>
        </div>
      </div>
      <div className="top-actions">
        <span className="preview-badge">{sq.app.versionBadge}</span>
        <span className="date-box" id="todayLabel">
          {today}
        </span>
      </div>
    </header>
  );
}
